import { sellerConstants } from '../../_constants/seller.constants';
import swal from 'sweetalert2';

const initialState = { sellCreditsLoading: true, data: '', error: false, errorText: '' };

export function sellCredit(state = initialState, action) {
    switch (action.type) {
        case sellerConstants.REQUEST_SELL_CREDITS:
            return {
                sellCreditsLoading: true,
                data: '',
                error: false,
                errorText: ''
            };
        case sellerConstants.RECEIVE_SELL_CREDITS:
        swal({
            text: "Credits Sold Successfully!",
            type:"success",
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
        })
            return {
                sellCreditsLoading: false,
                data: action.data,
                error: false,
                errorText: ''
            };
        case sellerConstants.SELL_CREDITS_ERROR:
            return {
                sellCreditsLoading: false,
                data: '',
                error: true,
                errorText: action.error
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/sellCredit.reducer.js